import React from "react";
import InspPackageReview from "./InspPackageReview";


interface SeniorInspReviewProps {
  activeWidget?: string;
  view?: __esri.MapView | __esri.SceneView;
  portal?:any
}

const SeniorInspReview: React.FC<SeniorInspReviewProps> = ({ activeWidget,view,portal }) => {
  const [visible, setVisible] = React.useState(false);
  const reviewDiv = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (activeWidget === "seniorInspReview") {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]);

  const style = { display: visible ? "initial" : "none", padding: '1rem' };

  return (
<div ref={reviewDiv} style={style}>
  <InspPackageReview view={view} portal={portal} />
</div>
  );
};

export default SeniorInspReview;

